<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.NOTIFICATION_TOOLS.TITLE' | translate }}</h4>

  <button mat-stroked-button type="button" (click)="previewNotification()">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.PREVIEW_NOTIFICATION' | translate }}
  </button>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.NOTIFICATION_TOOLS.TYPE' | translate }}</mat-label>
    <mat-select [formControl]="notifTypeControl">
      @for (option of notifTypeOptions; track option.value) {
        <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="backgroundColorControl"
    labelTranslateKey="PRESENTER.NOTIFICATION_TOOLS.BACKGROUND_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="notifSecondaryBackgroundColorControl"
    labelTranslateKey="PRESENTER.NOTIFICATION_TOOLS.SECONDARY_BACKGROUND_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="notifSecondaryColorControl"
    labelTranslateKey="PRESENTER.NOTIFICATION_TOOLS.SECONDARY_TEXT_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>

  <mat-slide-toggle [formControl]="showBidNotificationsControl">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.SHOW_BID_NOTIFICATIONS' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="showPurchaseNotificationsControl">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.SHOW_PURCHASE_NOTIFICATIONS' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="showDonationNotificationsControl">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.SHOW_DONATION_NOTIFICATIONS' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="showCustomNotificationsControl">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.SHOW_CUSTOM_NOTIFICATIONS' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="hideNameControl">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.HIDE_NAME' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="hidePriceControl">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.HIDE_PRICE' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="imageContainedControl">
    {{ 'PRESENTER.NOTIFICATION_TOOLS.IMAGE_CONTAINED' | translate }}
  </mat-slide-toggle>
</div>
